(function () {
  'use strict';

  angular.module('sempraWebapp').factory('GivenLoyaltyPerDayReportViewModel', givenLoyaltyPerDayReportViewModelFactory);

  /** @ngInject */
  function givenLoyaltyPerDayReportViewModelFactory(reportActions, localeFilters, reportsFilterStore, $translate, dispatcher, ActionTypesEnum) {
    function GivenLoyaltyPerDayReportViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.total = 0;
      this.totalByGroupName = [];
      this.chart = {
        data: null,
        chartType: 'bar',
        x: {
          type: 'timeseries',
          tick: {
            culling: { max: 15 },
            rotate: 60,
            format: function (item) {
              return localeFilters.date(item);
            }
          }
        }
      };

      init.call(this);
    }

    GivenLoyaltyPerDayReportViewModel.prototype.destroy = function () {
      reportsFilterStore.off(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    };

    return GivenLoyaltyPerDayReportViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };
      reportsFilterStore.on(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();
      that.total = 0;
      that.totalByGroupName = [];
      reportActions.getTotalSpentLocalTokensPerDay(reportFilterData.fromTimestamp, reportFilterData.toTimestamp).then(function (successData) {

        that.total = successData.total;
        successData.groupTotal.forEach(function (item, index) {
          that.totalByGroupName.push({
            total: item,
            name: successData.groupNames[index]
          });
        });

        //successData.unit = 'TOTAL_USERS_BY_GROUP_USERS_UNIT';
        that.chart.data = successData;
        that.unit = $translate.instant('LOCAL_TOKEN');
        that.isChartVisible = (successData.total !== 0) ? true : false;
        dispatcher.dispatch({
          type: ActionTypesEnum.HIDE_LOADER
        });
      });
    }
  }
})();
